export default {
  queryCsPunish: '/gateway/capp/courier_operations/queryCsPunish',
  submitAppeal: '/gateway/capp/courier_operations/submitAppeal'
}
